var map = {
	"./activerecord.en.yml": 513,
	"./d2p.en.yml": 514,
	"./devise.en.yml": 515,
	"./en-GB.yml": 516,
	"./en.yml": 517,
	"./kaminari.en.yml": 518,
	"./simple_form.en.yml": 519,
	"./system_campaigns.en-GB.yml": 520,
	"./system_campaigns.en.yml": 521,
	"./system_campaigns.fr.yml": 522,
	"./wwd_community.en.yml": 523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 512;